<template>
  <ul class="list-group hosts_count_picker">
    <li class="list-group-item px-0 pt-0">
      <div class="row person-range-picker-group">

        <div class="col person-range-picker-desc">
          <p class="h5">
            <strong class="d-block">{{ $t('adults') }}</strong>
            <small class="fw-normal">{{ $t('adults-caption') }}</small>
          </p>
        </div>

        <div class="col person-range-picker">

          <button @click="changeCount('adult', 'minus')" type="button" :disabled="hosts.adult <= 0"
                  :class="hosts.adult > 0 ? 'active' : ''">
            <TyIcon icon="ty-minus-2" width="2.4rem"></TyIcon>
          </button>

          <span class="number">{{ hosts.adult }}</span>

          <button @click="changeCount('adult', 'plus')" type="button" class="active">
            <TyIcon icon="ty-plus-2" width="2.4rem"></TyIcon>
          </button>

        </div>

      </div>
    </li>
    <li class="list-group-item px-0">
      <div class="row person-range-picker-group">
        <div class="col person-range-picker-desc">
          <p class="h5">
            <strong class="d-block">{{ $t('childrens') }}</strong>
            <small class="fw-normal">{{ $t('childrens-caption') }}</small>
          </p>
        </div>
        <div class="col person-range-picker">
          <button @click="changeCount('child', 'minus')" type="button"
                  :class="hosts.child > 0 ? 'active' : ''">
            <TyIcon icon="ty-minus-2" width="2.4rem"></TyIcon>
          </button>
          <span class="number">{{ hosts.child }}</span>
          <button @click="changeCount('child', 'plus')" type="button" class="active">
            <TyIcon icon="ty-plus-2" width="2.4rem"></TyIcon>
          </button>
        </div>
      </div>
    </li>
    <li class="list-group-item px-0">
      <div class="row person-range-picker-group">
        <div class="col person-range-picker-desc">
          <p class="h5">
            <strong class="d-block">{{ $t('newborns') }}</strong>
            <small class="fw-normal">{{ $t('newborns-caption') }}</small>
          </p>
        </div>
        <div class="col person-range-picker ">
          <button @click="changeCount('newborn', 'minus')" type="button"
                  :class="hosts.newborn > 0 ? 'active' : ''">
            <TyIcon icon="ty-minus-2" width="2.4rem"></TyIcon>
          </button>
          <span class="number">{{ hosts.newborn }}</span>
          <button @click="changeCount('newborn', 'plus')" type="button" class="active">
            <TyIcon icon="ty-plus-2" width="2.4rem"></TyIcon>
          </button>
        </div>
      </div>
    </li>
    <li class="list-group-item px-0">
      <div class="row person-range-picker-group">
        <div class="col person-range-picker-desc">
          <p class="h5">
            <strong class="d-block">{{ $t('rooms') }}</strong>
            <small class="fw-normal">{{ $t('rooms-caption') }}</small>
          </p>
        </div>
        <div class="col person-range-picker ">
          <button @click="changeCount('rooms', 'minus')" type="button"
                  :class="hosts.rooms > 1 ? 'active' : ''">
            <TyIcon icon="ty-minus-2" width="2.4rem"></TyIcon>
          </button>
          <span class="number">{{ hosts.rooms }}</span>
          <button @click="changeCount('rooms', 'plus')" type="button" class="active">
            <TyIcon icon="ty-plus-2" width="2.4rem"></TyIcon>
          </button>
        </div>
      </div>
    </li>
  </ul>
</template>

<script setup lang="ts">
import "~/assets/less/product_filter_index_guest_picker.min.css";
import {PropType, ref} from "vue";
import {reactive} from "#imports";

const props = defineProps({
  initHosts: Object as PropType<{ adult: number, child: number, newborn: number, rooms: number }>,
})

const emit = defineEmits(['updateHosts'])

const hosts = ref({adult: 0, child: 0, newborn: 0, rooms: 1});

hosts.value.adult = props.initHosts.adult;
hosts.value.child = props.initHosts.child;
hosts.value.newborn = props.initHosts.newborn;
hosts.value.rooms = props.initHosts.rooms ?? 1;

const update = () => {
  emit('updateHosts', hosts.value);
}

const changeCount = (type, way) => {
  if (hosts.value[type] !== undefined) {
    if (way === 'plus') {
      hosts.value[type]++;
    } else if (way === 'minus' && ((hosts.value[type] > 0 && type !== 'rooms') || (hosts.value[type] > 1 && type === 'rooms'))) {
      hosts.value[type]--;
    }
    update();
  }
}

</script>

